<template>
    <div class="content">
        <div :class="['header_back']">
            <div class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{$route.meta.title}}
        </div>
        <div class="back_warp">
            <div class="content-info">
                <div class="info-top">
                    <div class="Dprog">3D方案</div>
                    <div class="number">{{new_code}}</div>
                </div>
                <div class="title">{{objAccount.new_address}}</div>
                <div class="plan_lable">
                    <p>{{ objAccount.new_area ? objAccount.new_area + ' m²' : '' }}</p>
                    <p>
                        {{ objAccount.new_roomnumber ? objAccount.new_roomnumber + '室' : '' }}{{
                            objAccount.new_hall ? objAccount.new_hall + '厅' : ''
                        }}{{ objAccount.new_toilet ? objAccount.new_toilet + '卫' : '' }}{{
                            objAccount.new_kitchen ? objAccount.new_kitchen + '厨' : ''
                        }}
                    </p>
                    <p>{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : '' }}</p>
                </div>
                <!-- <div class="lable">
                    <div class="square">{{ objAccount.new_area ? objAccount.new_area + ' m²' : '不详' }}</div>
                    <div class="room">
                        {{objAccount.new_roomnumber ? objAccount.new_roomnumber + "室" : ""}}{{objAccount.new_hall ? objAccount.new_hall + "厅" : ""}}{{objAccount.new_toilet ? objAccount.new_toilet + "卫" : ""}}
                    </div>
                    <div class="type">{{ objAccount.new_housetype_name ? objAccount.new_housetype_name : "不详" }}</div>
                </div> -->
            </div>
            <div class="threeBox">
                <div class="title">3D设计方案</div>
                <iframe width="100%" height="100%" :src="url"></iframe>
            </div>
            <div class="home_icon" @click="getHome"  :style="{bottom: showInfo == 2 ? '108px':'88px'}">
                <img  src="@/assets/images/member/v2/plan/home_icon.png"/>
            </div>
            <share :isFixed="true" v-if="showInfo == 2"></share>
        </div>
    </div>
</template>

<script>
    import share from '../components/share.vue'
    let matched = [];
    export default {
        components: {
            share
        },
        data() {
            return {
                bBack: matched.length,
                objAccount: [],
                url: '',
                new_code: '',
                showInfo:false,
            }
        },
        beforeRouteEnter(to,from,next){
            matched = from.matched;
            next();
        },
        created() {
            Promise.all([
                this.$userHouse.dispatch("getAppHouser",{ mobile: this.$route.query.appmob || this.$storage.getStorage('app_mob'), contractid: this.$route.query.contractid || this.$route.query.contractId })
            ]).then((res) => {
                this.objAccount = this.$userHouse.state.usreAppHouserList.account; // 用户信息
                this.new_code = this.$userHouse.state.usreAppHouserList.contract.new_code
                if (this.$route.query.url) {
                    this.url = this.$route.query.url
                    console.log(this.url, '2')
                } else {
                    let btn = this.$userHouse.state.usreAppHouserList.btn;
                    btn.forEach((item) => {
                        if (item.type_key == 'third_img') {
                            this.url = item.type_id
                            console.log(this.url, '1')
                        }
                    })
                }
            }).catch((error) => console.log());

        },
        mounted() {
            console.log(this.$route.query.url, 'url')
        },
        methods: {
            goback(){
                if (!this.bBack) {
                    this.$router.replace({
                        path: `/member/v3/index/index?appmob=${this.$route.query.appmob || this.$storage.getStorage('app_mob')}`
                    })
                } else {
                    this.$router.go(-1);
                }
            },
            getHome(){
                this.$router.push({
                    path: `/member/v3/index/index?appmob=${this.$route.query.appmob || this.$storage.getStorage('app_mob')}`,
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .content {
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
        padding-bottom: env(safe-area-inset-bottom);
        .header_back{
            background: #FFF;
            padding-top: 60px;
            box-sizing: border-box;
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            position: relative;
            .back_icon{
                position: absolute;
                left: 50px;
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                span{
                    display: block;
                    width: 18px;
                    height: 18px;
                    border: 3px solid #000;
                    border-right: 0;
                    border-bottom: 0;
                    transform: rotate(-45deg);
                }
            }
        }
        .back_warp{
            height: calc(100vh - env(safe-area-inset-bottom) - 180px);
            overflow-x: hidden;
            overflow-y: scroll;
            background: #7AA894;
        }

        .content-info {
            padding: 64px 64px 48px 56px;

            .info-top {
                display: flex;
                justify-content: space-between;

                .Dprog {
                    width: 112px;
                    height: 40px;
                    background: #0D53FC;
                    border-radius: 21px;
                    text-align: center;
                    line-height: 42px;
                    font-size: 22px;
                    color: #FFFFFF;
                    font-weight: 400;
                }

                .number {
                    height: 40px;
                    font-size: 20px;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 40px;
                }
            }

            .plan_lable {
                margin-top: 40px;

                p {
                    padding: 0 32px;
                    display: inline-block;
                    font-size: 24px;
                    color: $whiteText;
                    color: rgba(255, 255, 255, 0.8);
                }

                p:nth-child(1) {
                    padding-left: 0;
                }

                p:nth-child(2) {
                    border-left: 1px solid rgba(255, 255, 255, 0.7);
                    border-right: 1px solid rgba(255, 255, 255, 0.7);
                }
            }

            .title {
                margin: 58px 0 32px 0;
                font-size: 36px;
                color: #FFFFFF;
            }

            .lable {
                margin-top: 32px;
                /* padding: 12px 0 32px 0; */
                display: flex;

                .square {
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                    padding-right: 32px;
                    border-right: 2px solid rgba(255, 255, 255, 0.7);
                }

                .room {
                    padding: 0 32px;
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                    border-right: 2px solid rgba(255, 255, 255, 0.7);
                }

                .type {
                    padding: 0 32px;
                    font-size: 24px;
                    color: rgba(255, 255, 255, 0.7);
                }
            }
        }

        .threeBox {
            width: 100%;
            height: 78vh;
            background: #F9F9F9;
            border-radius: 24px 24px 0px 0px;

            .title {
                font-size: 32px;
                font-weight: 500;
                color: #333333;
                padding: 64px 64px 32px 64px;
            }
        }
        .home_icon{
            position: fixed;
            right: 4px;
            img{
                width: 112px;
                height: 112px;
            }
        }
    }
</style>
